import React, { useEffect, useState, useContext } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Form,
} from "reactstrap";
import Select from "react-select";
import { postSalidasImportFile } from "../../helpers/backend_helper";
import { getStorageCompany } from "../../helpers/api_helper";
import { Alert, ToastHelper } from "../../helpers/alerts/alertHelper";
import Validate from "./Validate";
import NibbleInput from "../../components/Fields/NibbleInput";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import axios, {AxiosError} from 'axios';


const BASE_URL_BACK = process.env.REACT_APP_BACKEND_API_LOGIN_URL;

const ImportModal = ({ modal, setModal, authUser, onComplete }) => {
  const company = getStorageCompany();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState([]);

  const handleClose = () => {
    setModal({ ...modal, show: false });
  };

  const save = async () => {
    setErrors([]);
    setLoading(true);
    let response = await postSalidasImportFile(validation.values.file);

	console.log(response);
	if (response instanceof AxiosError) {
		console.log(response.response.data.errors);
      	setErrors(response.response?.data?.errors ?? {0: 'Error al importar'});
	} else {
		setModal({ ...modal, show: false });
		setErrors([]);
		onComplete();
	}
    
    setLoading(false);
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { file: null },
    validationSchema: Yup.object({
      file: Yup.string().nullable(true).required("Requerido"),
    }),
    onSubmit: async (values) => {
      await save();
    },
  });

  return (
    <div>
      <Modal isOpen={modal.show}>
        <Form
          onSubmit={(event) => {
            event.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalHeader className="bg-primary">Importar</ModalHeader>
          <ModalBody>
            <div className="row">
              <p>
                Seleccione el archivo excel que contiene las salidas, el formato
                debe ser como el siguiente archivo de ejemplo{" "}
                <Link
                  className="btn btn-sm btn-primary"
                  to={{ pathname: BASE_URL_BACK + "/formato_salidas.xlsx" }}
                  target="_blank"
                >
                  <i className="fa fa-file-excel"></i> Formato
                </Link>
              </p>

              <NibbleInput
                md={12}
                label="Archivo:"
                fieldName="file"
                fieldType="file"
                validation={validation}
                accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              />

              <p className="mt-2">
                {Object.entries(errors).map((error) => (
                  <div
                    className="alert alert-danger"
                    key={error[0]}
                    type="danger"
                    title="Error"
                  >
                    {"Linea " + error[0] + ": " + error[1]}
                  </div>
                ))}
              </p>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit" disabled={loading}>
              {loading && <Spinner size="sm"></Spinner>}{" "}
              <i className="fa fa-file-import"></i> Importar
            </Button>{" "}
            <Button type="button" color="secondary" onClick={handleClose}>
              <i className="fa fa-times"></i> Cancelar
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default ImportModal;
